import React, { useEffect, useMemo } from 'react';

import { ModalCloseButton, ModalContent } from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';

import { Modal } from 'components';
import { baseFilters } from 'constants/table';
import { AccessTypes } from 'enums/types';
import { policy } from 'polices';

import CheckBoxFilters from './Checkboxes';
import Footer from './Footer';
import Header from './Header';
import SelectFilter from './Select';

export default function Filters({
  isOpen, onClose, filters, setFilters,
}) {
  const { content } = useParams<GeneralRoute>();
  const {
    register, handleSubmit, setValue, reset,
  } = useForm();

  useEffect(() => {
    Object.entries(filters).forEach(([key, value]: [string, string[]]) => {
      const baseValues = Object.values(baseFilters[content].checkbox[key]);

      value.forEach((item) => {
        const index = baseValues.findIndex((baseValue) => baseValue === item);
        setValue(`${key}.${index}`, item);
      });
    });
  }, [filters]);

  const onSubmit = (data) => {
    const keys = Object.keys(baseFilters[content].checkbox);
    const parsedFilters = {};
    keys.forEach((key) => {
      parsedFilters[key] = data[key].filter((item) => item);
    });
    setFilters(parsedFilters);
    reset();
  };

  const selectOptions = useMemo(() => baseFilters[content].select.filter((item) => {
    if (item.policy) {
      const [context, method] = item.policy.split('.');
      return policy(context)(method) === AccessTypes.Allow;
    }
    return true;
  }), [baseFilters, content]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}>
      <ModalContent>
        <ModalCloseButton />
        <Header />
        <SelectFilter
          options={selectOptions}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <CheckBoxFilters register={register} />
          <Footer
            onClose={onClose}
          />
        </form>
      </ModalContent>
    </Modal>
  );
}
